import { PlatformSystemSettingsApi } from '@evimo/client/apis';
import { createApiConfiguration } from '~/app/lib/api-config';

export const platformSettingsApi = new PlatformSystemSettingsApi(
  createApiConfiguration(),
);

export const platformSettingsRequestInit = {
  credentials: 'include' as const,
};
